<div class="container  mt-5">
	<nb-card class="card">
		<h1 class="main-title">Keni harruar fjalekalimin?</h1>
		<p class="paragraph mb-5">
			Ju lutemi shkruani email adresën tuaj të regjistruar. Ne do t'ju dërgojmë
			një email për të rivendosur fjalëkalimin tuaj.
		</p>

		<form [formGroup]="forgotPasswordForm">
			<label class="short-paragraph mb-2">Email adresa</label>
			<div class="input-group mb-4">
				<input
					type="text"
					class="form-control input"
					placeholder="example@mail.com"
					formControlName="email"
				/>
				<span *ngIf="submitted && emailError" class="error-message"
					>Ju lutem shkruani email addresen!</span
				>
			</div>

			<button
				type="submit"
				class="blue-button mt-1"
				[nbSpinner]="requesting"
				[disabled]="requesting"
				(click)="emitForm()"
			>
				Dergo
			</button>
		</form>
	</nb-card>
</div>
